// extracted by mini-css-extract-plugin
module.exports = {"Nav":"MobileNavigation_Nav__3nTEr","Disabled":"MobileNavigation_Disabled__1fLoI"};